import { Image, Link, Flex } from '@chakra-ui/react'
import Logo from '../../assets/Logo.png'
import LanguageButton from '../_shared/LanguageButton'

export default function MainLogo() {
  return (
    <Flex mb={4} justify="space-between" align="center">
      <Link href="/">
        <Image
          src={Logo}
          alt="Logo Carefl.ai"
          maxW={{ base: '120px', md: '150px' }}
          h="auto"
          objectFit="contain"
        />
      </Link>
      <LanguageButton color="brand.purple" />
    </Flex>
  )
}
